import React from "react";
import { Row } from "antd";

export default props => {
    return (
        <Row gutter={24} style={{
            borderBottom: props.noBorder ? "unset" : "1px solid #eceef1",
            paddingBottom: 16,
            marginTop: 16,
            display: "flex",
            alignItems: "center"
        }}>
            {props.children}
        </Row>
    )
}
